import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  House, Users, Buildings, FileText, Receipt, ListChecks, ChartBar, ChartLineUp, IdentificationCard, Gear,
  Wrench, Bank, Warning, CurrencyEur, Briefcase, Archive, ShieldCheck, BookmarkSimple, Stack, EnvelopeSimple,
  ClipboardText, Handshake, Gavel, Calendar, Storefront, Tray, TrendUp, MapTrifold,
  Calculator, CaretDown, SquaresFour, UserList, Scales, Coins, HandCoins, Invoice, Folders, FileMagnifyingGlass,
  PencilSimpleLine, Tray as TrayIcon, Notebook, Stamp, PiggyBank, Gauge, Key, Signature,
} from "@phosphor-icons/react";

export const NAV_GROUPS = [
  { id: "start", items: [
    { to: "/", label: "Dashboard", icon: SquaresFour, testid: "nav-dashboard", end: true },
    { to: "/postfach", label: "Postfach", icon: Tray, testid: "nav-postfach" },
    { to: "/vorgaenge", label: "Vorgänge", icon: Briefcase, testid: "nav-vorgaenge" },
    { to: "/aufgaben", label: "Aufgaben", icon: ListChecks, testid: "nav-tasks", module: "aufgaben" },
  ] },
  { id: "stammdaten", label: "Stammdaten", items: [
    { to: "/kontakte", label: "Kontakte", icon: IdentificationCard, testid: "nav-contacts", module: "crm" },
    { to: "/objekte", label: "Objekte", icon: Buildings, testid: "nav-properties" },
    { to: "/mietverhaeltnisse", label: "Mietverhältnisse", icon: House, testid: "nav-tenancies" },
    { to: "/zaehler", label: "Zähler", icon: Gauge, testid: "nav-zaehler" },
  ] },
  { id: "vermietung", label: "Vermietung", items: [
    { to: "/vermarktung", label: "Vermarktung", icon: Storefront, testid: "nav-vermarktung" },
    { to: "/besichtigungen", label: "Besichtigungen", icon: Calendar, testid: "nav-besichtigungen" },
    { to: "/uebergabetermine", label: "Übergabetermine", icon: Key, testid: "nav-uebergabetermine" },
    { to: "/mieterhoehungen", label: "Mieterhöhungen", icon: TrendUp, testid: "nav-mieterhoehungen" },
    { to: "/vergleichsmieten", label: "Vergleichsmieten", icon: MapTrifold, testid: "nav-vergleichsmieten" },
  ] },
  { id: "instandhaltung", label: "Instandhaltung", items: [
    { to: "/tickets", label: "Tickets", icon: Wrench, testid: "nav-tickets", module: "schadensmanagement" },
    { to: "/schaeden", label: "Schäden", icon: Warning, testid: "nav-damages" },
  ] },
  { id: "finanzen", label: "Finanzen", items: [
    { to: "/bank", label: "Bank", icon: Bank, testid: "nav-bank", module: "zahlungsmanagement", end: true },
    { to: "/bank/inbox", label: "Bank-Inbox", icon: TrayIcon, testid: "nav-bank-inbox", module: "zahlungsmanagement" },
    { to: "/zahlungsaufforderungen", label: "Zahlungsaufforderungen", icon: HandCoins, testid: "nav-dunning-v2", module: "objektbuchhaltung" },
    { to: "/abschlaege", label: "Abschläge", icon: Coins, testid: "nav-installments", module: "zahlungsmanagement" },
    { to: "/rechnungen", label: "Rechnungen", icon: Invoice, testid: "nav-invoices" },
    { to: "/kosten", label: "Kosten", icon: CurrencyEur, testid: "nav-cost-positions", module: "objektbuchhaltung" },
    { to: "/kaution", label: "Kautionen", icon: PiggyBank, testid: "nav-kaution" },
  ] },
  { id: "abrechnungen", label: "Abrechnungen", items: [
    { to: "/betriebskosten", label: "Betriebskosten", title: "Betriebskostenabrechnung", icon: Calculator, testid: "nav-bka", module: "nebenkostenabrechnung" },
    { to: "/weg-jahresabrechnung", label: "WEG-Jahresabrechnung", icon: Receipt, testid: "nav-wegja" },
    { to: "/beleg-pruefungen", label: "Belegeinsicht", icon: FileMagnifyingGlass, testid: "nav-beleg-pruefungen" },
    { to: "/anfechtungen", label: "Anfechtungen", icon: Gavel, testid: "nav-challenges" },
  ] },
  { id: "weg", label: "WEG & Verträge", items: [
    { to: "/weg", label: "WEG-Verwaltung", icon: Users, testid: "nav-weg" },
    { to: "/vertraege", label: "Verträge", icon: Signature, testid: "nav-contracts" },
    { to: "/verwaltervertraege", label: "Verwalterverträge", icon: Handshake, testid: "nav-mgmt-contracts" },
    { to: "/kostenblatt", label: "Kostenblatt", icon: Notebook, testid: "nav-kostenblatt" },
    { to: "/seg/analysen", label: "SEG-Analysen", icon: Scales, testid: "nav-seg-analyses" },
  ] },
  { id: "auswertungen", label: "Auswertungen", items: [
    { to: "/auswertungen", label: "Auswertungen", icon: ChartBar, testid: "nav-analytics", module: "reporting" },
    { to: "/eigentumerreport", label: "Eigentümerreport", icon: UserList, testid: "nav-owner-report", module: "reporting" },
    { to: "/steuerberater-auswertung", label: "Steuerberater", icon: ChartLineUp, testid: "nav-tax-advisor", module: "reporting" },
    { to: "/finanzen/steuer/mahngebuehren", label: "Mahngebühren", icon: Stamp, testid: "nav-mahngebuehren-report", module: "reporting" },
  ] },
  { id: "dokumente", label: "Dokumente", items: [
    { to: "/entwuerfe", label: "Entwürfe", icon: PencilSimpleLine, testid: "nav-drafts" },
    { to: "/dokumente", label: "Dokumente", icon: Folders, testid: "nav-documents", module: "dokumentenmanagement" },
    { to: "/protokolle", label: "Protokolle", icon: ClipboardText, testid: "nav-protocols" },
    { to: "/amtliche-dokumente", label: "Amtliche Dokumente", icon: FileText, testid: "nav-official-docs" },
    { to: "/archiv", label: "Archiv", icon: Archive, testid: "nav-archive" },
    { to: "/dokument-pruefen", label: "Dokument prüfen", icon: ShieldCheck, testid: "nav-verify" },
  ] },
  { id: "vorlagen", label: "Vorlagen", adminOnly: true, items: [
    { to: "/vorlagen", label: "Brief-Vorlagen", icon: BookmarkSimple, testid: "nav-templates", adminOnly: true },
    { to: "/vertragsvorlagen", label: "Vertragsvorlagen", icon: Briefcase, testid: "nav-contract-templates", adminOnly: true },
    { to: "/email-vorlagen", label: "E-Mail-Layouts", icon: EnvelopeSimple, testid: "nav-email-templates", adminOnly: true },
    { to: "/bausteine", label: "Textbausteine", icon: Stack, testid: "nav-snippets", adminOnly: true },
    { to: "/stammdaten?tab=letterhead", label: "Geschäftspapier", icon: FileText, testid: "nav-letterhead", adminOnly: true },
  ] },
  { id: "verwaltung", label: "Verwaltung", adminOnly: true, items: [
    { to: "/stammdaten", label: "Stammdaten", icon: IdentificationCard, testid: "nav-stammdaten", adminOnly: true },
    { to: "/benutzer", label: "Benutzer", icon: Users, testid: "nav-users", adminOnly: true },
    { to: "/rollen", label: "Rollen & Rechte", icon: ShieldCheck, testid: "nav-rollen", adminOnly: true },
    { to: "/einstellungen", label: "Einstellungen", icon: Gear, testid: "nav-settings", adminOnly: true },
  ] },
];

const KEY = "domivus.nav.open";
const isActive = (it, path) => (it.end ? path === it.to : path === it.to.split("?")[0] || path.startsWith(`${it.to.split("?")[0]}/`));

function NavItem({ it, collapsed, badge }) {
  const Icon = it.icon;
  return (
    <NavLink to={it.to} end={it.end} data-testid={it.testid} title={collapsed ? it.title || it.label : it.title}
      className={({ isActive: a }) => `group relative mx-2 my-px flex items-center gap-2.5 rounded-md text-[13px] font-medium transition-colors ${collapsed ? "justify-center px-0 py-2" : "px-3 py-1.5"} ${
        a ? "bg-slate-900 text-white" : "text-slate-700 hover:bg-slate-100"}`}>
      <Icon size={18} weight="regular" className="shrink-0" />
      {!collapsed && <span className="truncate">{it.label}</span>}
      {badge > 0 && (collapsed
        ? <span className="absolute right-1.5 top-1 h-2 w-2 rounded-full bg-teal-500" data-testid="nav-postfach-count" />
        : <span className="ml-auto min-w-[20px] h-5 px-1.5 rounded-full bg-teal-600 text-white text-[11px] font-semibold flex items-center justify-center tabular-nums" data-testid="nav-postfach-count">{badge > 99 ? "99+" : badge}</span>)}
    </NavLink>
  );
}

export function SidebarNav({ isVisible, collapsed, postfachCount }) {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(() => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } });
  const groups = NAV_GROUPS.map((g) => ({ ...g, items: g.items.filter(isVisible) })).filter((g) => g.items.length && isVisible(g));
  const activeGroup = groups.find((g) => g.items.some((it) => isActive(it, pathname)))?.id;
  useEffect(() => { if (activeGroup && open[activeGroup] === false) setOpen((o) => ({ ...o, [activeGroup]: true })); }, [activeGroup]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(open)); }, [open]);
  return (
    <nav className="flex-1 py-2 overflow-y-auto overflow-x-hidden" data-testid="sidebar-nav">
      {groups.map((g) => {
        const isOpen = !g.label || collapsed || (open[g.id] ?? g.id === activeGroup);
        const slug = g.id;
        return (
          <div key={g.id} className={g.label ? "mt-1" : ""} data-testid={`nav-group-${slug}`}>
            {g.label && (collapsed
              ? <div className="mx-4 my-2 border-t border-stone-200" />
              : <button type="button" onClick={() => setOpen((o) => ({ ...o, [g.id]: !isOpen }))} aria-expanded={isOpen}
                  className="w-full flex items-center justify-between px-5 pt-2.5 pb-1 text-[10px] uppercase tracking-wider font-semibold text-slate-400 hover:text-slate-700 transition-colors"
                  data-testid={`nav-section-${slug}`}>
                  <span className="flex items-center gap-1.5">{g.label}{!isOpen && g.id === activeGroup && <span className="h-1.5 w-1.5 rounded-full bg-slate-900" />}</span>
                  <CaretDown size={11} weight="bold" className={`transition-transform duration-200 ${isOpen ? "" : "-rotate-90"}`} />
                </button>)}
            <div className={`grid transition-[grid-template-rows] duration-200 ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
              <div className="overflow-hidden">
                {g.items.map((it) => <NavItem key={it.to} it={it} collapsed={collapsed} badge={it.to === "/postfach" ? postfachCount : 0} />)}
              </div>
            </div>
          </div>
        );
      })}
    </nav>
  );
}
